export default __webpack_public_path__ + "static/media/entuber-logo.5503f863.png";